Ext.define('SA.CrosstabState', {
    borderWidth: 1,

    config: {
        cellWidth: 180,
        cellHeight: 60,
        leftWidth: 302,
        topHeight: 98
    },

    constructor({location, maxSize, onChange}) {
        this.location = location;
        this.maxSize = maxSize;
        this.attributes = null;
        this.cache = new SA.CrosstabDataCache({location, refreshHandler: this.onChange.bind(this)});
        this.defaultMode = true;
        this.drag = {attribute: null, originalPosition: null};
        this.selectedAttribute = null;

        this.changeHandler = onChange;
    },

    clearDrag() {
        this.set({drag: {attribute: null, originalPosition: null}});

        this.refreshCache();
    },

    clearSelected() {
        if (this.hasSelectedAttribute()) {
            this.set({selectedAttribute: null});
        }
    },

    cloneAttributes() {
        return this.attributes.clone();
    },

    dragTo(position) {
        position.index += position.top ? this.columnOffset : this.rowOffset;

        this.setDragPosition(position);
    },

    getColumnAndRowCount() {
        var attributeCounts = this.attributes.getCounts();

        return {rowCount: attributeCounts.left + 1, columnCount: attributeCounts.top + 1};
    },

    getFrame({rect}) {
        var grid = this.getGrid(),
            {offset, indexes} = SA.Frame.get({rect, grid}),
            data = this.getTplData({indexes});

        this.rowOffset = indexes.rows[0];
        this.columnOffset = indexes.columns[0];

        return {offset, data};
    },

    getGrid() {
        var {cellWidth, cellHeight} = this.config,
            {rowCount, columnCount} = this.getColumnAndRowCount(),
            rows = [],
            columns = [];

        for (let i = 0; i < rowCount; i++) {
            let cumulativeTopBorders = (i + 1) * this.borderWidth,
                top = (i * cellHeight) + cumulativeTopBorders,
                bottom = top + cellHeight;

            rows.push({top, bottom, index: i});
        }

        for (let i = 0; i < columnCount; i++) {
            let cumulativeLeftBorders = (i + 1) * this.borderWidth,
                left = (i * cellWidth) + cumulativeLeftBorders,
                right = left + cellWidth;

            columns.push({left, right, index: i});
        }

        return {rows, columns};
    },

    getSelectedAttribute() {
        return this.selectedAttribute;
    },

    getSizing() {
        var {topHeight, leftWidth, cellWidth, cellHeight} = this.config,
            {rowCount, columnCount} = this.getColumnAndRowCount(),
            intrinsicWidth = (columnCount * (cellWidth + this.borderWidth)) + leftWidth + this.borderWidth,
            intrinsicHeight = (rowCount * (cellHeight + this.borderWidth)) + topHeight + this.borderWidth,
            intrinsicSize = {width: intrinsicWidth, height: intrinsicHeight},
            {size: constrainedSize, hasScrollX, hasScrollY} = SA.ConstrainedSize.get({intrinsicSize, maxSize: this.maxSize});

        return {leftWidth, topHeight, intrinsicSize, constrainedSize, hasScrollX, hasScrollY};
    },

    getTplData({indexes}) {
        var me = this,
            isDragging = id => id === this.drag.attribute,
            top = indexes.columns.map(index => index === 0 ? 'total' : this.attributes.get({top: index - 1})),
            left = indexes.rows.map(index => index === 0 ? 'total' : this.attributes.get({left: index - 1}));

        return {
            top: top.map(getHeaderEntry),
            left: left.map(getHeaderEntry),
            body: left.map(left => top.map(top => getBodyEntry({left, top})))
        };

        function getHeaderEntry(id) {
            var isTotal = id === 'total',
                dragging = isDragging(id),
                selected = me.isSelected(id);

            return {id, isTotal, dragging, selected};
        }

        function getBodyEntry({left, top}) {
            var ids = {left, top},
                isDefaultMode = me.isDefaultMode(),
                {loading, empty, data} = me.cache.get(SA.CrosstabDataId.get([left, top])),
                dragging = isDragging(left) || isDragging(top);

            return {isDefaultMode, ids, location: me.location, dragging, loading, empty, data};
        }
    },

    hasSelectedAttribute() {
        return this.getSelectedAttribute() !== null;
    },

    isDefaultMode() {
        return this.defaultMode;
    },

    isSelected(attribute) {
        return attribute === this.selectedAttribute;
    },

    isSingleAttributeInSide(attribute) {
        return this.attributes.isSingleAttributeInSide(attribute);
    },

    onChange() {
        if (!this.cache.hasData()) {
            return;
        }

        this.changeHandler();
    },

    refreshCache() {
        var attributes = new SA.CrosstabRequestAttributes(this.attributes.getArrays());

        this.cache.request(attributes);
    },

    removeAttribute(attribute) {
        this.attributes.remove(attribute);

        this.onChange();
    },

    revertDrag() {
        this.setDragPosition(this.drag.originalPosition);
    },

    set(source) {
        Object.assign(this, source);

        this.onChange();
    },

    setAttributes(attributes) {
        this.set({attributes});

        this.refreshCache();
    },

    setDragPosition(position) {
        if (!this.attributes.hasPosition(this.drag.attribute, position)) {
            this.attributes.moveTo(this.drag.attribute, position);

            this.onChange();
        }
    },

    setIsDefaultMode(defaultMode) {
        this.set({defaultMode});
    },

    setIsDragging(attribute) {
        var originalPosition = this.attributes.getPosition(attribute);

        this.set({drag: {attribute, originalPosition}, selectedAttribute: null});
    },

    setMaxSize(maxSize) {
        this.set({maxSize, selectedAttribute: null});
    },

    setSelected(attribute) {
        this.set({selectedAttribute: attribute});
    }
});